(function () {
  'use strict';
  var text = 'Google und Meta erfassen mit Ihrer Erlaubnis, über welche Anzeige Sie kommen (Klick-Kennungen, 90 Tage im Browser). Wir melden ihnen Anfragen, Klicks auf Telefon und WhatsApp und Online-Käufe nach einer Anfrage. Google und Meta nutzen die Daten auch selbst, auch in den USA. Änderbar unter „Cookie-Einstellungen“.';
  function update() {
    var description = document.querySelector('#shopify-pc__prefs__marketing > p');
    if (description && description.textContent !== text) {
      description.textContent = text;
      description.setAttribute('data-jb-banner-version', 'banner-2026-10-24-v1');
    }
  }
  update();
  new MutationObserver(update).observe(document.body, { childList: true, subtree: true });
})();
